import FormulaError from './FormulaError.js';

// Token types
export const NUMBER = 'number';
export const REF = 'ref';
export const IDENT = 'ident';
export const OP = 'op';
export const LPAREN = '(';
export const RPAREN = ')';
export const COMMA = ',';

const REF_PATTERN = /^\[\[([^[\]]+)\]\]/;
const NUMBER_PATTERN = /^(\d+(\.\d*)?|\.\d+)/;
const IDENT_PATTERN = /^[A-Za-z_]\w*/;
// Longest operators first so "<=" wins over "<"
const OPERATORS = ['<=', '>=', '<>', '<', '>', '=', '+', '-', '*', '/'];

/*
  Splits a formula into tokens. Column references use the [[accessor]] syntax
  produced by the FormulaEditor.

  tokenize('IF([[a]] < 10, 10, 20)')
  // => [{type: 'ident', value: 'IF'}, {type: '('}, {type: 'ref', value: 'a'}, ...]
*/
export const tokenize = (formula) => {
  const tokens = [];
  let pos = 0;

  while (pos < formula.length) {
    const rest = formula.slice(pos);
    const char = rest[0];

    if (/\s/.test(char)) {
      pos += 1;
      continue;
    }

    const ref = rest.match(REF_PATTERN);
    if (ref) {
      tokens.push({ type: REF, value: ref[1], pos });
      pos += ref[0].length;
      continue;
    }

    const number = rest.match(NUMBER_PATTERN);
    if (number) {
      tokens.push({ type: NUMBER, value: parseFloat(number[0]), pos });
      pos += number[0].length;
      continue;
    }

    const ident = rest.match(IDENT_PATTERN);
    if (ident) {
      tokens.push({ type: IDENT, value: ident[0].toUpperCase(), pos });
      pos += ident[0].length;
      continue;
    }

    if (char === LPAREN || char === RPAREN || char === COMMA) {
      tokens.push({ type: char, pos });
      pos += 1;
      continue;
    }

    const op = OPERATORS.find(o => rest.startsWith(o));
    if (op) {
      tokens.push({ type: OP, value: op, pos });
      pos += op.length;
      continue;
    }

    throw new FormulaError('formula_error_unexpected_token', pos, { token: char });
  }

  return tokens;
};
